import { Button, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ToWords } from "to-words";
import GlobalCurrency from "../GlobalCurrency";
import { UilImport } from '@iconscout/react-unicons'
import { environment } from "../../../shared/config/environment";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";



const MobileInvoice = ({ item }) => {
    const navigate = useNavigate()
    const { tenants, user, accessToken } = useSelector((state) => state?.auth);
    const words = new ToWords().convert(item?.grand_total);
    const billingAddress = item?.order_billing_addresses[0];
    const currentTenant = useSelector((state) => state?.sharedSlice?.currentTenant)
    console.log("currentTenant", currentTenant)

    const handlePrint = async () => {
        try {
            var config = {
                method: "GET",
                url: environment.URL + `tenant-invoice-data?order_id=${item?.id}&app_flavor=${currentTenant?.flavor}`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
                responseType: "blob",
            };
            const printData = await axios(config);
            const pdfBlob = new Blob([printData.data], { type: "application/pdf" });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(pdfBlob);
            link.setAttribute("download", `${item?.order_number}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toast.success("PDF download successfully")
        } catch (error) {
            toast.error("Error while downloading PDF. please try again later");
            console.log("error", error)
        }
    }

    const fetchRazorpayKey = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}tenants/razorpay-key`);
            const data = await response.json();
            return data.razorpay_key;
        } catch (error) {
            console.error('Error fetching Razorpay key:', error);
            return null;
        }
    };


    const handlePayment = async (row) => {
        const orderId = item.id;
        const planId = item.selected_plan?.id;
        const planPeriod = item.selected_plan?.period;

        if (!planId) {
            console.error("Plan ID is missing for the selected order.");
            return;
        }
        //const subscriptionId = await createSubscription(planId);
        //if (!subscriptionId) return;

        const RAZORPAY_KEY = await fetchRazorpayKey();
        if (!RAZORPAY_KEY) {
            console.error("Failed to fetch Razorpay key");
            return;
        }
        const amountInPaise = parseInt(item.grand_total * 100);


        const options = {
            key: RAZORPAY_KEY,
            currency: "INR",
            amount: amountInPaise,
            name: user.name,
            description: "Test Transaction",
            handler: async function (response) {

                try {
                    const verifyResponse = await fetch(
                        `${process.env.REACT_APP_API_URL}tenants/verification`,
                        {
                            method: "POST",
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                                "X-Tenant": user?.currentTenant,
                            },
                            body: JSON.stringify({
                                razorpay_payment_id: response.razorpay_payment_id,
                                orderCreationId: orderId,
                                tenantId: user?.currentTenant,
                                period: planPeriod,
                                amount: item?.grand_total,
                            }),
                        }
                    );

                    const data = await verifyResponse.json();


                    if (response.razorpay_payment_id) {
                        alert("Payment processed successfully");
                        navigate("/billing");
                        //window.location.reload();
                    } else {
                        alert("Payment process failed");
                        //window.location.reload();
                        navigate("/billing");
                    }
                } catch (error) {
                    console.error("Error:", error);
                    alert("Payment process failed");
                }
            },
            prefill: {
                name: user.name,
                email: user.email,
                contact: user.contact,
            },
            notes: {
                address: "Corporate Office",
                plan_id: planId,
            },
            theme: {
                color: "#F37254",
            },
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.open(); // Directly open the Razorpay payment page
    };

    return (
        <>
            <ToastContainer />
            <Row className="mb-2">
                <Col lg={12}>
                    <text ># {item?.order_number}</text>
                </Col>
            </Row>
            {!billingAddress && <Row className="mt-2">
                <Col lg={12}>
                    <span className="mb-0" style={{ fontWeight: '600', fontSize: '13px' }}>Bill To</span>
                </Col>
                <span className="mb-0 text-truncate" style={{ fontWeight: '500', fontSize: '12px', textTransform: 'capitalize' }}>
                    {billingAddress ? item?.order_billing_addresses[0]?.name : user?.name}
                </span>
                <Col lg={12}>
                    <span style={{ fontSize: "12px", fontWeight: 400 }}>
                        <text style={{ fontSize: "12px", fontWeight: 600 }}>Phone &nbsp;: &nbsp;</text> {billingAddress ? item?.order_billing_addresses[0]?.phone_number : user?.phone}
                    </span>
                </Col>
            </Row>}
            {billingAddress && <Row>
                <Col lg={12} className="">
                    <text className="mb-0" style={{ fontWeight: '600', fontSize: '13px' }}>Bill To &nbsp;</text>
                </Col>
                <Col lg={12}>
                    <text className="mb-0" style={{ fontWeight: '500', fontSize: '12px', textTransform: 'capitalize' }}>
                        {item?.order_billing_addresses[0]?.name}
                    </text>
                </Col>
                {billingAddress?.address1 && (
                    <Col lg={12}>
                        <text className="mb-0" style={{
                            fontSize: "12px",
                            fontWeight: 400,
                        }}>
                            {item?.order_billing_addresses[0]?.address1}
                            {item?.order_billing_addresses[0]?.address1 && ','}&nbsp;
                            {item?.order_billing_addresses[0]?.address2}
                            {item?.order_billing_addresses[0]?.address2 && ','}
                        </text>
                    </Col>
                )}
                {billingAddress?.city && (
                    <Col lg={12}>
                        <text className="mb-0" style={{
                            fontSize: "12px",
                            fontWeight: 400,
                        }}>
                            {item?.order_billing_addresses[0]?.city}
                            {item?.order_billing_addresses[0]?.city && ' , '}
                            {billingAddress?.state && ` ${item?.order_billing_addresses[0]?.state}`}
                            {billingAddress?.state && billingAddress?.pincode && ' - '}
                            {billingAddress?.pincode && ` ${item?.order_billing_addresses[0]?.pincode}`}
                        </text>
                    </Col>
                )}
                {billingAddress?.gstin && (
                    <Col lg={12}>
                        <text className="mb-0" style={{
                            fontSize: "12px",
                            fontWeight: 400,
                        }}>
                            <span style={{ fontWeight: '600' }}>GSTIN : </span>   {item?.order_billing_addresses[0]?.gstin}
                        </text>
                    </Col>
                )}
                {billingAddress?.phone_number && (
                    <Col lg={12}>
                        <text style={{
                            fontSize: "12px",
                            fontWeight: 400,
                        }}>
                            <span style={{ fontWeight: '600' }}>Phone : </span>   {item?.order_billing_addresses[0]?.phone_number}
                        </text>
                    </Col>
                )}
            </Row>}
            <hr />
            {item?.order_items?.filter(oi => (oi?.quantity ?? 0) > 0)?.map((oi, idx) => {
                const isPlan = !!oi?.plan;
                const name = isPlan ? oi?.plan?.label : oi?.addon?.label;
                const unitPrice = isPlan ? oi?.plan?.price : oi?.addon?.price;
                return (
                    <Row className="mt-2" key={idx}>
                        <Col lg={12} className="d-flex justify-content-between">
                            <div>
                                <text>{name} {isPlan ? '( Plan )' : '( Addon )'}</text>
                            </div>
                            <div>
                                <GlobalCurrency value={unitPrice} />
                            </div>
                        </Col>
                        <Col lg={12}>
                            <div>
                                <text>QTY &nbsp;  X &nbsp; {oi?.quantity}</text>
                            </div>
                        </Col>
                    </Row>
                );
            })}
            <hr />
            <Row className="mt-2">
                <Col lg={12} className="d-flex justify-content-between mb-1">
                    <div>
                        <text>Taxable Amount</text>
                    </div>
                    <div>
                        <GlobalCurrency value={item?.taxable_value} />
                    </div>
                </Col>

                <Col lg={12}>
                    <div className="d-flex justify-content-between mb-1">
                        <text>CGST @ {item?.selected_plan?.tax_rate / 2}%</text>
                        <GlobalCurrency value={item?.tax_total / 2} />
                    </div>

                </Col>
                <Col lg={12}>
                    <div className="d-flex justify-content-between mb-1">
                        <text>SGST @ {item?.selected_plan?.tax_rate / 2}%</text>
                        <GlobalCurrency value={item?.tax_total / 2} />
                    </div>

                </Col>
                <Col lg={12} className="d-flex justify-content-between mb-1">
                    <div>
                        <text>Total</text>
                    </div>
                    <div>
                        <GlobalCurrency value={item?.grand_total} />
                    </div>
                </Col>
                <Col lg={12} className="d-flex justify-content-between mb-1">
                    <div>
                        <text>Paid</text>
                    </div>
                    <div>
                        <GlobalCurrency value={item?.paid_amount} />
                    </div>
                </Col>
                <Col lg={12} className="d-flex justify-content-between mb-1">
                    <div>
                        <text>Balance</text>
                    </div>
                    <div>
                        <GlobalCurrency value={item?.grand_total - item?.paid_amount} />
                    </div>
                </Col>
            </Row>
            <hr />

            <Row className="">
                <Col lg={6} md={6} sm={6} xs={6}>
                    <Button variant="outline-primary w-100 px-2" onClick={handlePrint} >
                        <UilImport className="mx-2" size="18" />
                        Download PDF
                    </Button>
                </Col>
                <Col lg={6} md={6} sm={6} xs={6}>
                    <Button className="w-100"
                        variant={item?.grand_total === item?.paid_amount ? "primary " : "outline-primary"}
                        disabled={item?.grand_total === item?.paid_amount}
                        onClick={handlePayment}
                    >
                        {item?.grand_total === item?.paid_amount ? "Paid" : "Pay"}
                    </Button>
                </Col>
            </Row>
            <hr />
            <Row className="">
                <Col lg={12}>
                    <text className="mb-0" style={{ fontWeight: '600', fontSize: '13px' }}>Terms And Conditions</text>
                </Col>
                <Col lg={12}>
                    <text style={{ fontSize: "12px", fontWeight: 400 }}>
                        1. Automatic Renewal: Your subscription renews automatically each billing cycle, and your payment method will be charged unless you cancel beforehand.
                    </text>
                </Col>
                <Col lg={12}>
                    <text style={{ fontSize: "12px", fontWeight: 400 }}>
                        2. Cancellation: Cancel anytime through your account. No refunds for partial billing cycles; service continues until the end of the current period.
                    </text>
                </Col>
            </Row>
            {/* <hr /> */}

        </>
    )
}

export default MobileInvoice;
